import React from 'react'
import { FaPix } from "react-icons/fa6";
import _get from "lodash/get";
import { Box, Link } from "@chakra-ui/react";
import { MainButton } from 'components/Button/MainButton';
import {ResgateProps} from '../dominio'
import { Input } from "components/Input";
import api from 'services/api';
import { useCustomToast } from "hooks/useToast";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';

let step2_Processando = false;

const Step2 = (props: any) => {
    const pageState: ResgateProps = props.pageState;
    const setPageState = props.setPageState;
    const maxReenvioCount = 20;

    const { getToast } = useCustomToast();
    const navigate = useNavigate();
    const [debug, setDebug] = React.useState<string>('');
    const [codigoConfirmacao, setCodigoConfirmacao] = React.useState<string>("");
    const [reenvioCount, setReenvioCount] = React.useState<number>(maxReenvioCount);

    const setProcessando = (value: boolean) => {
        if (value === false) {
          setReenvioCount(maxReenvioCount);
        }
         
        step2_Processando = value;
        setPageState({...pageState, processando: value});
    }

    const Enviar = async () => {

      if (step2_Processando === true)
        return;

      if (!codigoConfirmacao || codigoConfirmacao.length < 6 || codigoConfirmacao.length > 8) 
      {
        getToast({messageError: 'codigo confirmação inválido', status: "warning" });
        return;
      }

      setProcessando(true);

      const body = {
        resgateProcessoId: Number(pageState.resgateProcessoId),
        resgateRef: pageState.resgateRef,
        codigoValidacao: codigoConfirmacao
      }
      try {
        const { status, data } = await api.post("/motorDePontos/resgate/confirmar", body);
        if (status === 200) {
          setPageState({...pageState, 
            processando: false, 
            step: 3,
            mensagemSucesso: data.mensagemSucesso || 'Resgate registrado com sucesso'
            });
        }
        else {
          setProcessando(false);
          setDebug(JSON.stringify({status, data}));
        }
        
      } catch (error: any) {
        setProcessando(false);
        const messageError = _get(error, "response.data.errors[0].message") || 'falha ao processar request';
        getToast({ messageError, status: "warning" });
        if (error.response) {
            setDebug(JSON.stringify({status: error.response.status, data: error.response.data, request: body}, null, 2));
        }
        else {
            setDebug(JSON.stringify({error: error.message, stack: error.stack, request: body}, null, 2));
        }
      } finally {

      }
      
    }

    const ReenviarCodigo = async () => {
      if (step2_Processando === true)
        return;
      setProcessando(true);
      try {
        const body = {
          resgateProcessoId: pageState.resgateProcessoId,
          resgateRef: pageState.resgateRef
        };
        const { status, data } = await api.post("/motorDePontos/resgate/codigo-confirmacao", body);
        setProcessando(false);
        getToast({messageError: 'Código reenviado com sucesso', status: "info" });
      } catch (error) {
        setProcessando(false);
        const messageError = _get(error, "response.data.errors[0].message") || 'falha ao processar request';
        getToast({ messageError, status: "warning" });
      }
    }
 

    React.useEffect(() => {
      if (pageState.step === 2 && reenvioCount < maxReenvioCount && step2_Processando === false) {
        setReenvioCount(maxReenvioCount);
      }
      
    }, [pageState.step]);

    React.useEffect(() => {
      if (reenvioCount > 0) {
        setTimeout(() => {
          setReenvioCount(valor => valor - 1);
        }, 1000);
      }
    }, [reenvioCount]);

    return (
    <div className='resgate_process_content'>
      <div className='resgate_process_content' style={{backgroundColor: 'rgb(3 155 86)', padding: '16px', width: '100%', color: '#ffffff'}}>Valide seu Resgate</div>
      <div className='resgate_process_panel'>
        <div className='resgate_process_panel_item' style={{ borderBottom: '#AAA solid 1px', fontWeight: 700}}>{pageState.resgatePontos} pontos</div>
        <div className='resgate_process_panel_item' style={{ borderBottom: '#AAA solid 1px'}}><span style={{color: '#088108', fontSize:'32px', marginRight: '16px'}}><FaPix /></span> {pageState.chave}</div>
        <div className='resgate_process_panel_item' >Valor a receber: <strong>R$ {pageState.resgateValor?.toFixed(2)}</strong></div>
        <div className='resgate_process_panel_item' style={{fontSize: '11pt'}} >Banco: {pageState.bancoDestino}</div>
        <div className='resgate_process_panel_item' style={{fontSize: '11pt'}}  >Titular: {pageState.nomeTitular}</div>
      </div>
      <div className='resgate_process_panel_item' >{pageState.mensagemConfirmacao}</div>
      <div className='resgate_process_panel'>
        <div className='resgate_process_panel_form' style={{paddingTop: '12px'}}>
          <Input 
                nameInput="txt_codigo"
                fontSize="14px"
                
                error={undefined}
                placeholder="000000"
                type="number"
                onChange={(e) => setCodigoConfirmacao(e.target.value)}
                value={codigoConfirmacao || ''}
            />

        </div>
        <div className='resgate_process_content_row' style={{paddingTop: '12px'}}>
          <MainButton
            isLoading={pageState.processando}
            onClick={() => Enviar()}
            width="250px"  
            fontSizeButton="20px"
            margim="0px 10px 5px 10px"   
            title="Confirmar"
          />
          <MainButton
              isLoading={pageState.processando}
              onClick={() => setPageState({...pageState, step: 1, resgateRef: uuidv4()})}
              backgroundColorButton="#10125A"
              width="250px"  
              fontSizeButton="20px"
              margim="0px 10px 5px 10px"  
              title="Voltar"
          />
        </div>
        <div className='resgate_process_panel_form'>
          {pageState.processando
          ? <>...</>
          : <>
            {reenvioCount <= 1 
              ? <Link onClick={() => ReenviarCodigo()} >Reenviar código</Link>
              : <>Reenvia codigo ({reenvioCount} segundos)</>
              }
            </>}
        </div>
      </div>
    </div>);
}

export default Step2

// 